import { QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Image, Modal } from 'antd';
import React, { useState } from 'react';

type Props = {};

const HelpModal = (props: Props) => {
  const [visibleHelpModal, setVisibleHelpModal] = useState<boolean>(false);
  return (
    <React.Fragment>
      <Button size='small' type='link' icon={<QuestionCircleOutlined />} onClick={() => setVisibleHelpModal(true)}>
        <u>&nbsp;Hướng dẫn</u>
      </Button>
      <Modal 
      title='HƯỚNG DẪN IN ĐỀ THI' 
      open={visibleHelpModal} 
      width={800}
      cancelText='Đóng' 
      onCancel={() => setVisibleHelpModal(false)}
      okButtonProps={{style:{display:'none'}}}
      bodyStyle={{
        minHeight: "400px",
        maxHeight: "80vh",
        overflowY: "auto"
      }}
      centered
      >
        <div>Hướng dẫn minh họa trên trình duyệt Chrome (tiếng Anh), thao tác tương tự với các trình duyệt khác</div>
        <div>- <b>Bước 1:</b> Nhấn vào nút "In"</div>
        <Image src='/images/prints/help/1.png' alt='1.png' style={{width: 100}}/>
        <div>- <b>Bước 2:</b> Hộp thoại thiết lập in hiện lên. Thiết lập các thông tin như hình dưới. Sau đó nhấn "Save"</div>
        <div className='center-mactching'><Image src='/images/prints/help/2.png' alt='2.png' style={{width: 200}}/></div>
        <div>- <b>Bước 3:</b> Hộp thoại chỉnh sửa tên file hiện lên. Nhập tên file (tên file nên là chuỗi không có dấu). Nhấn "Save" và file sẽ được tải xuống.</div>
        <div className='center-mactching'><Image src='/images/prints/help/3.png' alt='3.png' style={{width: 200}}/></div>
        <hr/>
        <h2 style={{textAlign:'center'}}>HƯỚNG DẪN CHUYỂN FILE PDF THÀNH DOCX</h2>
        <div>- <b>Bước 1:</b> Truy cập vào đường dẫn <a target='_blank' href='https://cloudconvert.com/pdf-to-docx'>https://cloudconvert.com/pdf-to-docx</a></div>
        <div>- <b>Bước 2:</b> Nhấn "Select File" để tải file pdf lên</div>
        <div className='center-mactching'><Image src='/images/prints/help/4.png' alt='4.png' style={{width: 200}}/></div>
        <div>- <b>Bước 3:</b> Nhấn "Convert" để bắt đầu chuyển đổi file pdf vừa tải thành docx.</div>
        <div className='center-mactching'><Image src='/images/prints/help/5.png' alt='5.png' style={{width: 200}}/></div>
        <div>- <b>Bước 4:</b> Nhấn "Download" để tài file docx về máy.</div>
        <div className='center-mactching'><Image src='/images/prints/help/6.png' alt='6.png' style={{width: 200}}/></div>
        <hr/>
        <h2 style={{textAlign:'center'}}>HƯỚNG DẪN TẢI FILE AUDIO VÀ VIDEO</h2>
        <div>&emsp; Đối với các bài tập có sử dụng Audio và Video. Đường dẫn của file sẽ được hiển thị ở mục <b>"--- ĐÁP ÁN VÀ FILE ĐÍNH KÈM ---"</b> của đề thi</div>
        <div className='center-mactching'><Image src='/images/prints/help/7.1.png' alt='7.1.png' style={{width: 400}}/></div>
        <div>- <b>Bước 1:</b> Nhập đường dẫn file vào trình duyệt</div>
        <div className='center-mactching'><Image src='/images/prints/help/7.png' alt='7.png' style={{width: 500}}/></div>
        <div>- <b>Bước 2:</b> Nếu đường dẫn file đúng thì trình duyệt sẽ hiển thị audio hoặc video</div>
        <div className='center-mactching'><Image src='/images/prints/help/10.1.png' alt='10.1.png' style={{width: 200}}/><span style={{width:10}}></span><Image src='/images/prints/help/8.png' alt='8.png' style={{width: 200}}/></div>
        <div>+ <b>Đối với audio:</b> Nhấn dấu 3 chấm ở bên phải thanh audio. Sau đó chọn "Download"</div>
        <div className='center-mactching'><Image src='/images/prints/help/10.1.png' alt='10.1.png' style={{width: 200}}/><span style={{width:10}}></span><Image src='/images/prints/help/10.2.png' alt='10.2.png' style={{width: 200}}/></div>
        <div>+ <b>Đối với video:</b> Nhấn dấu 3 chấm ở góc dưới - bên phải của video. Sau đó chọn "Download"</div>
        <div className='center-mactching'><Image src='/images/prints/help/9.1.png' alt='9.1.png' style={{width: 200}}/><span style={{width:10}}></span><Image src='/images/prints/help/9.2.png' alt='9.2.png' style={{width: 200}}/></div>
        
      </Modal>
    </React.Fragment>
  );
};

export default HelpModal;
